import type * as Permission from "./type"
import { request } from "@/http/axios"

/** 获取当前登录用户详情 */
export function GetPermission() {
  return request<Permission.GetPermissionResponseData>({
    url: "/api/user/menu",
    method: "GET"
  })
}
